import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Pool/generarExcel`, method: 'POST', body: values, token: token})
}
